
import { FieldType, Model, Schema } from "@core/index";
import { ICountry } from "./Country";

export enum TravelDocType { PSPT, IDCD, VISA }

export interface ITravelDoc {
    id?: string;
    documentType?: TravelDocType;
    holderNationality?: string;
    issuer?: ICountry;
    issueCountry?: string;
    applicable?: ICountry;
    applicableCountry?: string;
    issueDate?: number;
    expireDate?: number;
}

export class TravelDoc extends Model implements ITravelDoc {
    public static schema: Schema = new Schema("TravelDoc");
    public id?: string;
    public documentType?: TravelDocType;
    public holderNationality?: string;
    public issuer?: ICountry;
    public issueCountry?: string;
    public expireDate?: number;

    constructor(values: ITravelDoc) {
        super(TravelDoc.schema);
        this.setValues(values);
    }
}

TravelDoc.schema.addField("id").type(FieldType.String).required();
TravelDoc.schema.addField("documentType").type(FieldType.Enum)
    .enum(TravelDocType.PSPT, TravelDocType.IDCD, TravelDocType.VISA).default(TravelDocType.PSPT);
TravelDoc.schema.addField("holderNationality").type(FieldType.String).required();
TravelDoc.schema.addField("issueCountry").type(FieldType.String).required();
TravelDoc.schema.addField("expireDate").type(FieldType.Number).required();
TravelDoc.schema.freeze();